import React from 'react';
import { withTheme } from 'styled-components';
import { Section } from '../../Section';
import { ReviewsBlock } from '../../Reviews';
import { getWriteReviewPath } from '../../Reviews/utils';
export var FundReviewsSummary = function FundReviewsSummary(_ref) {
  var theme = _ref.theme,
    reviews = _ref.reviews,
    fund = _ref.fund,
    user = _ref.user,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    product = _ref.product,
    finectApp = _ref.finectApp;
  var path = getWriteReviewPath(theme, fund);
  var headerLink = product && product.hasOwnProperty('entity') && product.entity.socialStats.reviews.total ? {
    href: path.url,
    text: "Escribe tu opini\xF3n",
    rel: 'nofollow'
  } : null;
  return React.createElement(Section, {
    id: "opiniones",
    bottomMargin: bottomMargin,
    title: "Puntuaci\xF3n y opiniones",
    headerLink: headerLink
  }, React.createElement(ReviewsBlock, {
    finectApp: finectApp,
    reviews: reviews,
    asideHidden: false,
    product: fund,
    me: user,
    showMoreButton: true,
    qty: 2
  }));
};
export default React.memo(withTheme(FundReviewsSummary));